import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from '../context/useAuth';

const Logout = () => {
  const { logout } = useAuth();
  const history = useHistory();

  useEffect(() => {
    logout();
    history.push('/login');
  }, [logout, history]);

  return "Thanks you. Bye!"; // You can return a loading spinner or a message if needed
};

export default Logout;